const actionTypes = {
    SIDEBAR : 'SIDEBAR'
};

export default actionTypes;